var render = function render(_c,_vm){return _c('div',[_c('i18n',{attrs:{"path":"Registration.agree_terms"}},_vm._l((_vm.$options.methods.getLinks(_vm.parent.$i18n.locale)),function(link){return _c('a',{key:link.place,attrs:{"place":link.place,"href":link.href,"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(_vm._s(_vm.parent.$t(link.text)))])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }